module.exports = __webpack_public_path__ + "img/cafeteria-menu-template-editable.a2b977ff.webp";